module.exports = "/assets/data/4c78561d8194bdbddc8dadc24e782913-E18.data.json";